import { useQuery } from "@tanstack/react-query"

import { getAgenda } from "../services/agenda.service";

export const useAgenda = (inicio, fin) => {

    const agendaQuery = useQuery({
        queryKey: ['agenda', { inicio, fin }],
        queryFn: () => getAgenda(inicio, fin),
        staleTime: 0, // nulo
        placeholderData: {
            citas: []
        }
    });

    return {
        agendaQuery,
    }
}